module.exports = __webpack_public_path__ + "img/login.394cbb93.jpg";